/**
 * Website page editor preview (sc-102217): publisher HTML is rendered into an iframe
 * (`srcDoc` in WebsiteContent). Requests must go through the dashboard API on the
 * editor origin (`/api/dashboard/booking-calendar/...`).
 */
export const isWebsitePreviewIframe = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    return window.parent !== window
  } catch {
    return false
  }
}

/**
 * Chooses booking-calendar HTTP API for the current preview context.
 *
 * - `isIframePreview` — explicit flag (e.g. PreviewBookingCalendar entity).
 * - `isPreviewMode` — Redux `management.previewMode` (true for any publisher preview,
 *   including funnel `?preview=` on the customer domain and website editor iframe).
 *
 * Dashboard API is used only in the editor iframe. Funnel/website preview opened in a
 * top-level window on the customer domain uses the public `/api/booking-calendar/...`
 * endpoints (same publisher bundle, different routes).
 */
export const shouldUseDashboardBookingApi = ({
  isIframePreview,
  isPreviewMode,
}: {
  isIframePreview?: boolean
  isPreviewMode: boolean
}): boolean =>
  isIframePreview ? true : isPreviewMode && isWebsitePreviewIframe()
